/**
 * Monitor auth performance and errors
 * Helps identify issues like excessive API calls or error patterns
 */
class AuthMonitor {
  private errorCount = 0;
  private requestCount = 0;
  private lastReset = Date.now();
  private readonly RESET_INTERVAL = 60000; // Reset counters every minute

  logRequest() {
    this.requestCount++;
    
    // Auto-reset counters every minute
    if (Date.now() - this.lastReset > this.RESET_INTERVAL) {
      this.reset();
    }
    
    // Warn if too many requests in short time
    if (this.requestCount > 10 && Date.now() - this.lastReset < 1000) {
      console.warn(`⚠️ [AuthMonitor] ${this.requestCount} auth requests in 1 second - possible issue`);
    }
  }

  logError(error: any) {
    this.errorCount++;
    
    if (error?.status === 409) {
      console.error('🔴 [AuthMonitor] 409 error - too many concurrent token refresh requests');
      console.error('💡 This should be prevented by authCache - check if cache is being bypassed');
    } else if (error?.status === 504) {
      console.error('🔴 [AuthMonitor] 504 timeout - token refresh took too long');
      console.error('💡 Network may be slow or Supabase may be under load');
    } else {
      console.error('🔴 [AuthMonitor] Auth error:', error);
    }
  }

  reset() {
    if (this.errorCount > 0 || this.requestCount > 20) {
      console.log(`[AuthMonitor] Reset - had ${this.requestCount} requests and ${this.errorCount} errors in last minute`);
    }
    this.errorCount = 0;
    this.requestCount = 0;
    this.lastReset = Date.now();
  }

  getStats() {
    return {
      errorCount: this.errorCount,
      requestCount: this.requestCount,
      duration: Date.now() - this.lastReset,
    };
  }
}

export const authMonitor = new AuthMonitor();
